import * as yup from 'yup';

export const conditionSchema = yup.object().shape({
	agreed: yup.bool(true).oneOf([true], 'Field must be checked'),
});
